export const ISO_DATE_JAPAN_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
export const DATE_FORMAT = "yyyy-MM-dd";
export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm";
export const DATETIME_WITH_SECONDS_FORMAT = "yyyy-MM-dd HH:mm:ss";
